import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '@/lib/site';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'product';
  structuredData?: any;
}

export function SEOHead({
  title = "รถมือสอง กรุงเทพ รถยุโรปมือสอง | TransShift - MotorVerified",
  description = "รถมือสอง กรุงเทพ รถยุโรปมือสอง BMW Mercedes Porsche มือสอง ราคาดี ไมล์แท้ เช็คราคารถมือสอง ซื้อขายรถมือสองคุณภาพ รับรอง MotorVerified ดูสต็อก 60+ คัน",
  keywords = "รถมือสอง กรุงเทพ, รถยุโรปมือสอง, รถหรูมือสอง, BMW มือสอง, Mercedes มือสอง, Porsche มือสอง, รถยนต์มือสอง ราคาดี, เช็คราคารถมือสอง, ซื้อรถมือสอง, รถมือสองคุณภาพ, รถบ้าน กรุงเทพ, MotorVerified, TransShift",
  image = "/og-image.jpg",
  url = SITE_URL,
  type = "website",
  structuredData,
}: SEOHeadProps) {
  return (
    <Helmet>
      {/* SVG favicon for modern browsers (best quality) */}
      <link rel="icon" type="image/svg+xml" href="/favicon.svg?v=7" />
      {/* PNG fallback */}
      <link rel="icon" type="image/png" href="/favicon.png?v=7" />
      <link rel="shortcut icon" href="/favicon.svg?v=7" />
      {/* Apple Touch Icons */}
      <link rel="apple-touch-icon" sizes="180x180" href="/favicon.png?v=7" />
      <link rel="apple-touch-icon" sizes="152x152" href="/favicon.png?v=7" />
      <link rel="apple-touch-icon" sizes="120x120" href="/favicon.png?v=7" />
      <link rel="apple-touch-icon" href="/favicon.png?v=7" />
      
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Geographic and Language Targeting */}
      <meta name="geo.region" content="TH" />
      <meta name="geo.placename" content="Bangkok, Thailand" />
      <meta property="og:locale" content="th_TH" />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical */}
      <link rel="canonical" href={url} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}
